var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
export function getDefinitions(pages) {
    var nodes = pages.map(function (_a) {
        var definition = _a.definition;
        return definition;
    });
    if (nodes.length <= 0)
        return "";
    return gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), reduceNodes(nodes));
}
export function getIncovations(pages) {
    if (pages.length <= 0)
        return "";
    var invocations = pages.map(function (_a) {
        var invocation = _a.invocation;
        return invocation;
    });
    return invocations.reduce(function (acc, curr) { return "".concat(acc).concat(curr); });
}
export function reduceNodes(nodes) {
    if (nodes.length <= 0)
        return "";
    var nodesReduced = nodes.reduce(function (acc, curr) {
        return gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        ", "\n        ", "\n      "], ["\n        ", "\n        ", "\n      "])), acc, curr);
    });
    return gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), nodesReduced);
}
var templateObject_1, templateObject_2, templateObject_3;
